export const getPageTitle = (): string => {
  const hostname = window.location.hostname;
  const defaultTitle = 'Algoricca App';

  // Se não for um domínio da Algoricca, retorna o título padrão
  if (!hostname.includes('.algoricca.com')) {
    return defaultTitle;
  }

  // Extrai o subdomínio (parte antes de .algoricca.com)
  const subdomain = hostname.split('.algoricca.com')[0];

  // Se não houver subdomínio ou for apenas 'www', retorna o título padrão
  if (!subdomain || subdomain === 'www') {
    return defaultTitle;
  }

  // Formata o título com base no subdomínio
  const formattedTitle = subdomain
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return formattedTitle;
};

export const updatePageTitle = (): void => {
  const title = getPageTitle();
  document.title = title;
};
